<template>
  <noticeViewAllList
    v-if="source === '1'"
    :currBreadCrumb="currBreadCrumb"
    :type="type"
  ></noticeViewAllList>
  <list
    v-else
    :currBreadCrumb="currBreadCrumb"
    :callInterface="callInterface"
    :otherParams="otherParams"
  ></list>
</template>

<script>
import { queryPublishedNoticeList } from "@/app/shop/api/shopping";
import list from "@/app/shop/components/list.vue";
import noticeViewAllList from "@/app/shop/components/noticeViewAllList.vue";
export default {
  name: "announcementsList",
  components: {
    list,
    noticeViewAllList
  },
  data() {
    return {
      currBreadCrumb: [],
      callInterface: queryPublishedNoticeList,
      otherParams: {
        agentId: 100131,
        module: 1,
        pageState: 2,
        appId: 100131
      },
      source: this.$route.query.source,
      type: this.$route.query.type
    };
  },
  activated() {
    if (this.source === "1") {
      switch (this.type) {
        case "3": //评标结果
          this.currBreadCrumb = [{ title: this.$t("page.content.labelMenu1") }];
          break;
        case "4": //中标通知
          this.currBreadCrumb = [{ title: this.$t("page.content.labelMenu5") }];
          break;
        case "7": //补遗公告
          this.currBreadCrumb = [{ title: this.$t("page.content.labelMenu3") }];
          break;
        case "8": //流标公告
          this.currBreadCrumb = [{ title: this.$t("page.content.labelMenu2") }];
          break;
      }
    } else {
      this.currBreadCrumb = [{ title: this.$t("page.content.Announcements") }];
    }
  }
};
</script>

<style scoped></style>
